import React from 'react';
import './contentStyle.scss';
import { connect } from 'react-redux';
import { REDUCER_NAME, updateUserSetting } from './../../reducer';
import SaveButton from './../footer-button-save/SaveButton';
import { Translate } from 'react-redux-i18n';
import { getUnique, isNotLogin } from './../../../../helpers/Common';

const listNotification = {
  NOTIFICATION_SUBSCRIBE: 'NOTIFICATION_SUBSCRIBE',
  NOTIFICATION_UNSUBSCRIBE: 'NOTIFICATION_UNSUBSCRIBE',
};

const NEWS_EMAIL_SUBSCRIBED = 'newsEmailSubscribed';
const NOTIFICATION_EMAIL_SUBSCRIBED = 'notificationEmailSubscribed';

class GeneralContentSetting extends React.Component {
  constructor(props) {
    super(props);
    const {
      notificationSubscribed,
      newsEmailSubscribed,
      notificationEmailSubscribed,
    } = this.props;
    this.state = {
      notificationSubscribed,
      newsEmailSubscribed,
      notificationEmailSubscribed,
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { notificationSubscribed } = this.props;
    if (notificationSubscribed !== nextProps.notificationSubscribed) {
      this.setState({
        notificationSubscribed: nextProps.notificationSubscribed,
      });
    }
  }

  handleChangeNotification = notificationSubscribed => () => {
    this.setState({
      notificationSubscribed,
    });
  };

  renderRowRadioButton = (key, checked, notificationSubscribed) => {
    return (
      <div className="row-content">
        <div
          className="radio-custom d-flex align-items-center"
          key={getUnique() + key}
          onClick={this.handleChangeNotification(notificationSubscribed)}
        >
          <input
            className={`radio-button`}
            type="radio"
            value={key}
            checked={checked}
            readOnly
          />
          <label className="ml-10">
            <Translate value={`systemSetting.listRadioNotification.${key}`} />
          </label>
        </div>
        <div className="line-dotted" />
      </div>
    );
  };

  handleChangeEmail = (key, checked) => () => {
    const { user } = this.props;
    if (isNotLogin(user)) {
      return;
    }
    this.setState({
      [key]: checked,
    });
  };

  renderRowCheckBox = (key, checked) => {
    return (
      <div
        className="checkbox wrap-checkbox-first-column-body"
        style={{ marginLeft: -5 }}
        key={getUnique() + key}
        onClick={this.handleChangeEmail(key, !checked)}
      >
        <input id={key} type="checkbox" checked={checked} readOnly />
        <label>
          <Translate value={`systemSetting.listCheckboxNotification.${key}`} />
        </label>
      </div>
    );
  };

  renderGroupButton = () => {
    return <SaveButton data={this.state} />;
  };

  render() {
    const {
      notificationSubscribed,
      newsEmailSubscribed,
      notificationEmailSubscribed,
    } = this.state;
    const { user } = this.props;

    return (
      <div className="setting-system-popup">
        <div className="row-content">
          <div className="wrap-row-notification">
            <span className="title-span w-100">
              <Translate value={`systemSetting.nodificationPlatform`} />
            </span>
          </div>
        </div>
        {this.renderRowRadioButton(
          listNotification.NOTIFICATION_SUBSCRIBE,
          notificationSubscribed,
          true,
        )}
        {this.renderRowRadioButton(
          listNotification.NOTIFICATION_UNSUBSCRIBE,
          !notificationSubscribed,
          false,
        )}
        <div className="row-content">
          <div
            className={`wrap-row-notification ${
              isNotLogin(user) ? 'guest' : ''
            }`}
          >
            <span className="title-span w-100 mb-5">
              <Translate value={`systemSetting.notificationTitle`} />
            </span>
            {this.renderRowCheckBox(NEWS_EMAIL_SUBSCRIBED, newsEmailSubscribed)}
            {this.renderRowCheckBox(
              NOTIFICATION_EMAIL_SUBSCRIBED,
              notificationEmailSubscribed,
            )}
          </div>
        </div>
        {this.renderGroupButton()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    notificationSubscribed:
      state[REDUCER_NAME].settingSystem.dataSystem.notificationSubscribed,
    newsEmailSubscribed:
      state[REDUCER_NAME].settingSystem.dataSystem.newsEmailSubscribed,
    notificationEmailSubscribed:
      state[REDUCER_NAME].settingSystem.dataSystem.notificationEmailSubscribed,
    user: state.userInfo,
  };
};
const mapDispatchToProps = {
  updateUserSetting,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GeneralContentSetting);
